import $ from 'jquery';
import jQuery from 'jquery';
import 'bootstrap';

// Sorting Display
import  sortingDisplay from './sorting_display/sortingDisplay.js';
sortingDisplay();

// Equal Footer Height
import equalFooterWidget from './match_height/equalHeight.js';
equalFooterWidget();

// Header Height
import headerHeight from './header-height/header_height.js';
headerHeight();

import './header-height/header_height.js';

// Select Dropdown
import SelectDropdown from './selectbox/selectDropdown';
SelectDropdown();

// Magnific Popup
import magnificPopupInit from './magnific-popup/magnific-popupInit.js';
magnificPopupInit();

// Skillbar
import skillbarInit from './skillbar/skillbarInit.js';
skillbarInit();

// Picture Fill
import pictureFillInit from './pictureFill/pictureFill.js';
pictureFillInit();

// Accordion
import accordionIconToggle from './accordion/accordionIconToggleInit.js';
accordionIconToggle();

// Remaining Gallery Number
import reaminingGalleryNum from './remainigGalleryNum/remainingGalleryNumInit.js';
reaminingGalleryNum();

// Filter Btn Expand/Collapsed
import filterBtnExpand from './filterBtnExpand/filterBtnExpandInit.js';
filterBtnExpand();

// Advanced Toggle Search
import advancedToggleInit from './advanced-search/advancedSearchToggle.js';
advancedToggleInit();

// Filter Toggle Search
import filterSearchToggle from './advanced-search/filterSearchToggleInit.js';
filterSearchToggle();

// Smooth Scroll
import smoothScrollInit from './smoothScroll/smoothScrollInit.js';
smoothScrollInit();

// Mobile Scroll Issue Fixed
import mobileScrollIssueInit from './mobileScrollIssue/mobileScrollIssueFix.js';
mobileScrollIssueInit();

// Fixed Search Map
import fixedMapInit from './fixed_search_map/fixedSearchMap.js';
fixedMapInit();

// Ratings
import ratingsInit from './ratings/ratyInit.js';
ratingsInit();

// Range Slider
import rangeSliderInit from './rangeSlider/rangeSliderInit.js';
rangeSliderInit();

// Swiper Slider
import swiperSliderInit from './swiperSlider/swiperSliderInit.js';
swiperSliderInit();

// Tags Remove
import tagsRemoveBtnInit from './tagRemoveBtn/tagRemoveBtnInit.js';
tagsRemoveBtnInit();

// Scroll Up
// import './scrollUp/jquery.scrollUp.min.js';
// import scrollUpInit from './scrollUp/scrollUpInit.js';
// scrollUpInit();

// Lazy Load
import lazyLoadInit from './lazyload/lazyLoadInit.js';
lazyLoadInit();

// Page Loading
import pageLoadingInit from './pageLoading/pageLoading.js';
pageLoadingInit();

// Typing Effect
import typeJSInit from './typedJs/typedJsInit.js';
typeJSInit();

// Full Height
// import fullHeightHeroInit from './hero-section-fullheight/heroFullHeightInit.js';
// fullHeightHeroInit();

// Side Menu
import sideMenuInit from './sidemenu/sidemenuInit.js';
sideMenuInit();






/** WEBPACK FOOTER **
 ** ./assets/src/js/scripts.js
 **/